/** True when a saved draft was built against an OLDER design revision than the
 *  template now loaded — i.e. the template was re-synced from Figma since the
 *  draft was saved. Used to show a one-time "your saved positions were reset"
 *  notice. Both revisions must be present numbers; a missing revision on either
 *  side (pre-Phase-0 drafts/templates) is treated as "not outdated" so no notice
 *  fires spuriously. */
export function isDraftBehindTemplate(
    draftContentRevision: unknown,
    templateContentRevision: unknown
): boolean {
    return (
        typeof draftContentRevision === 'number' &&
        typeof templateContentRevision === 'number' &&
        draftContentRevision < templateContentRevision
    );
}
